/* Routes for the team area (Area C: account). Paths are relative; see src/app/routes.ts. */
import { page, type AreaRoutes } from '@/app/routes'

export const routes: AreaRoutes = {
  shell: [{ path: 'team/*', lazy: page(() => import('./pages/TeamPage')) }],
  // the invitee opens this from the email, signed in or not
  public: [{ path: 'invite/:token', lazy: page(() => import('./pages/AcceptInvitePage')) }],
}
